import React from 'react';
import { Link } from 'react-router-dom';
import StandardDate from './StandardDate.js';
import formatAssetUrl from '../helpers/formatAssetUrl.js';

import '../styles/relatedContent.css';

const RelatedContentItem = ({ contentItem }) => {
    const pageData = contentItem.data || contentItem.page || null;

    const itemImage = formatAssetUrl({
        path: pageData?.image,
        fallback: `${process.env.PUBLIC_URL}/assets/images/related-placeholder.jpg`
    });

    return (
        <Link className="card" to={`/story/${contentItem.urn}`}>
            <div className="image-wrapper">
                <div className="image" style={{ backgroundImage: `url('${itemImage}')` }} />
            </div>
            <div className="details">
                <StandardDate date={contentItem.publishDate ? new Date(contentItem.publishDate) : null} className="date" inline={true} />
                <div className="title">{pageData?.title || contentItem.urn}</div>
            </div>
        </Link>
    );
};

const RelatedContent = ({ heading = null, content = [], padding = true }) => {
    if(!content.length) {
        return null;
    }

    return (
        <div className="related-content">
            {
                heading && <h3 className="heading">{heading}</h3>
            }

            <div className="cards">
                { content.map(contentItem => <RelatedContentItem key={contentItem.urn} contentItem={contentItem} />) }
            </div>
        </div>
    );
};

export default RelatedContent;
